/* import __COLOCATED_TEMPLATE__ from './revision.hbs'; */
import Component from "@glimmer/component";
import { service } from "@ember/service";

export default class Revision extends Component {
  @service site;
}
